<template>
  <div class="setting-page">
    <div class="panel">
      <div class="title">审计日志</div>
      <div class="filter-row">
        <DatePicker v-model="filters.start" placeholder="开始日期" style="width:150px"></DatePicker>
        <span>至</span>
        <DatePicker v-model="filters.end" placeholder="结束日期" style="width:150px"></DatePicker>
        <Select v-model="filters.module" :datas="moduleOptions" placeholder="模块" style="width:160px"></Select>
        <input type="text" v-model="filters.action" placeholder="操作" />
        <Select v-model="filters.success" :datas="statusOptions" placeholder="状态" style="width:120px"></Select>
        <input type="text" v-model="filters.user" placeholder="用户ID" />
        <Button color="primary" @click="search">检索</Button>
        <Button @click="reset">重置</Button>
        <Button @click="clearAll">清除</Button>
      </div>
    </div>

    <div class="panel">
      <Table :datas="datas" stripe>
        <TableItem title="创建时间" prop="createTime" :width="160"></TableItem>
        <TableItem title="用户" prop="user" :width="130"></TableItem>
        <TableItem title="模块" prop="module" :width="110"></TableItem>
        <TableItem title="操作" prop="action" :width="120"></TableItem>
        <TableItem title="请求方法" prop="method" :width="80"></TableItem>
        <TableItem title="请求路径" prop="path"></TableItem>
        <TableItem title="IP" prop="ip" :width="130"></TableItem>
        <TableItem title="耗时(ms)" prop="costMs" :width="90"></TableItem>
        <TableItem title="成功" :width="70">
          <template slot-scope="{ data }">
            <span :class="data.success ? 'ok' : 'fail'">{{ data.success ? '成功' : '失败' }}</span>
          </template>
        </TableItem>
      </Table>
      <Pagination v-model="pagination" @change="loadData" layout="pager" small align="center" v-if="datas.length" />
      <p v-if="!datas.length" class="empty">暂无审计日志（进行任意操作后此处会自动记录）</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditLogIndex',
  data() {
    return {
      filters: { start: '', end: '', module: '', action: '', success: '', user: '' },
      moduleOptions: [{ title: '全部模块', key: '' }],
      statusOptions: [{ title: '全部', key: '' }, { title: '成功', key: 1 }, { title: '失败', key: 0 }],
      datas: [],
      pagination: { page: 1, size: 10, total: 0 }
    };
  },
  mounted() {
    this.loadModules();
    this.loadData();
  },
  methods: {
    loadModules() {
      this.$api.setting.auditLog.modules().then((res) => {
        const list = (res.data || []).filter(Boolean);
        this.moduleOptions = [{ title: '全部模块', key: '' }].concat(
          list.map((m) => ({ title: m, key: m }))
        );
      });
    },
    buildParams() {
      const p = { page: this.pagination.page, pageSize: this.pagination.size };
      if (this.filters.start) p.start = this.filters.start;
      if (this.filters.end) p.end = this.filters.end;
      if (this.filters.module) p.module = this.filters.module;
      if (this.filters.action) p.action = this.filters.action;
      if (this.filters.success !== '' && this.filters.success !== null) p.success = this.filters.success;
      if (this.filters.user) p.user = this.filters.user;
      return p;
    },
    loadData() {
      this.$api.setting.auditLog.page(this.buildParams()).then((res) => {
        this.datas = res.data.records || [];
        this.pagination.total = res.data.total || 0;
      });
    },
    search() {
      this.pagination.page = 1;
      this.loadData();
    },
    reset() {
      this.filters = { start: '', end: '', module: '', action: '', success: '', user: '' };
      this.search();
    },
    clearAll() {
      this.$Confirm('确认清除本账套所有审计日志？').then(() => {
        this.$api.setting.auditLog.clear().then(() => {
          this.$Message.success('已清除');
          this.loadData();
        });
      });
    }
  }
};
</script>

<style scoped>
.setting-page { padding: 16px; }
.panel { background: #fff; border-radius: 4px; padding: 16px; margin-bottom: 16px; }
.title { font-size: 16px; font-weight: bold; margin-bottom: 12px; }
.filter-row { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.empty { text-align: center; color: #aaa; padding: 20px; }
.ok { color: #15a000; }
.fail { color: #d23f3f; }
</style>
